import React, { useState, useEffect } from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AppAppBar from "../homePage/AppAppBar";
import './hero.css';


export default function Hero() {
  const navigate = useNavigate();

  const handlePricing = () => {
    navigate(`/pricing`);
    console.log("this click will go to pricing page ");
  };

  const [currentImage, setCurrentImage] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [isChanging, setIsChanging] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  const images = [
    require("../img/laptop-crop.png"),
    require("../img/006-risk.png"),
    require("../img/008-ews.png"),
    require("../img/009 .png"),
  ];
  const contentTexts = [
    // "Get a Risk Report on any Company or Individual you are dealing with!",
    "Make your investments in Stocks, Mutual Funds, Bonds, F&O, PMS, AIF & many other assets. Directly check latest updates from 60000+ Companies",
    "Make your investments BulletProof. Directly get easy to read and analysis signals from 60000+ Companies . Get a Risk Report on any Company or Individual you are dealing with!",
  ];

  const [text, setText] = useState(" Portfolio");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const texts = ["ROI ", " Investment ", " Portfolio "];
      setIndex((index + 1) % texts.length);
      setText(texts[index]);
    }, 4050);

    return () => clearInterval(interval);
  }, [index]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      setCurrentImage(0);
      return;
    }

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const imageHeight = window.innerHeight;
      const imageIndex = Math.min(
        Math.floor(scrollTop / imageHeight),
        images.length - 2
      );

      if (imageIndex !== currentImage) {
        setIsChanging(true);
        setOpacity(0); // Start fading out
        setTimeout(() => {
          setCurrentImage(imageIndex);
          setOpacity(1); // Fade in after image changes
          setIsChanging(false);
        }, 200); // Adjust this timing to match the transition duration
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentImage, images.length, isMobile]);

  const renderDesktopContent = () => (
    <Box
      id="hero"
      sx={(theme) => ({
        width: "100%",
        backgroundImage:
          theme.palette.mode === "light"
            ? "linear-gradient(180deg, #B355F6, #FFF)"
            : "linear-gradient(#B355F6, #090E10)",
        backgroundSize: "100% 2.5%",
        backgroundRepeat: "no-repeat",
      })}
    >
      <Container
        className="hero-container"
        sx={{
          height: "90vh",
          position: "sticky",
          top: "28%", // Keep the Hero sticky
        }}
      >
        <Box
          className="content-box"
          sx={{
            flex: 1,
            zIndex: 2,
          }}
        >
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <Typography
              className="heading_1"
              component="h4"
              variant="h4"
              sx={{
                textAlign: "left",
                width: "50%",
              }}
            >
              <span style={{ fontSize: "120%" }}>Do A Comprehensive </span>
              <span style={{ color: "#750AC2", fontSize: "120%" }}>Check</span>
            </Typography>
          </div>
          <div style={{ textAlign: "left", width: "50%" }}>
            <Typography
              className="heading_2"
              component="h4"
              variant="h4"
              sx={{
                textAlign: "left",
              }}
            >
              <span style={{ fontSize: "120%" }}>on any Company or </span>
              <span style={{ color: "#750AC2", fontSize: "120%" }}>
                Individual
              </span>
            </Typography>
            <br />
            <br />
            {currentImage === 0 ? (
              <Typography textAlign="left" style={{ fontSize: "160%" }}>
                Grow your{" "}
                <span
                  style={{
                    fontSize: "130%",
                    fontWeight: "bold",
                    color: "#696969",
                  }}
                >
                  {text}
                </span>{" "}
                with all-in-one portfolio tracking and early warning information
                solution.
              </Typography>
            ) : (
              <Typography
                id="content-text"
                textAlign="left"
                style={{
                  fontSize: "160%",
                  transition: "opacity 0.5s",
                  opacity,
                  visibility: isChanging ? "hidden" : "visible",
                }}
              >
                {contentTexts[currentImage - 1]}
              </Typography>
            )}
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "normal" }}>
            <Button
              className="Check_Prices"
              variant="contained"
              onClick={handlePricing}
              color="primary"
              sx={{ mt: 2, width: "40%", fontSize: "130%" }}
            >
              Check Prices
            </Button>
          </div>
        </Box>

        {/* Image Container */}
        <Box
          className="image-container"
          sx={{
            position: "absolute",
            right: 0,
            width: "40%",
            top: "-1%",
          }}
        >
          <Box
            className="first_image"
            sx={{
              position: "sticky",
              top: "8%",
              width: "auto",
              height: "60vh",
              overflow: "hidden", // add this
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              className="image-wrapper"
              sx={{
                position: "relative",
                top: "-6%",
                width: "100%",
                height: "auto",
                overflow: "hidden", // add this
              }}
            >
              <img
                className="blank-laptop"
                src={require("../img/laptop-crop.png")}
                alt="Blank Laptop"
                style={{
                  width: "100%",
                  height: "auto",
                  overflow: "hidden",
                  // borderRadius: 10,
                }}
              />
              {images.slice(1).map((image, i) => (
                <Box
                  id="image-box"
                  key={i}
                  sx={{
                    position: "absolute",
                    top: `${currentImage === i ? 1 : 100}%`,
                    left: "10.1%",
                    width: "89%",
                    height: "auto",
                    overflow: "hidden",
                    transition: "top 0.5s ease-in-out",
                  }}
                >
                  <img
                    id="image"
                    src={image}
                    alt={`Slide ${i + 1}`}
                    style={{
                      width: "90%",
                      height: "auto",
                      borderRadius: 8,
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Container>

      {/* Empty Space to Allow Scroll */}
      <Box
        sx={{
          height: `${(images.length - 1) * 100}vh`,
          backgroundColor: "transparent",
        }}
      ></Box>
    </Box>
  );

  const renderMobileContent = () => (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        textAlign: "left",
      }}
    >
      <Box
        sx={{
          position: "relative",
          top: "15%",
          // left:"15%"
        }}
      >
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <Typography
            className="heading_1"
            component="h4"
            variant="h4"
            sx={{
              textAlign: "center",
              width: "100%",
            }}
          >
            <span style={{ fontSize: "110%" }}>Do A Comprehensive </span>
            <span style={{ color: "#750AC2", fontSize: "120%" }}>Check</span>
          </Typography>
        </div>
        <div style={{ textAlign: "center", width: "100%" }}>
          <Typography
            className="heading_2"
            component="h4"
            variant="h4"
            sx={{
              textAlign: "center",
            }}
          >
            <span style={{ fontSize: "110%" }}>on any Company or </span>
            <span style={{ color: "#750AC2", fontSize: "120%" }}>
              Individual
            </span>
          </Typography>
        </div>
        <div style={{ display: "flex", gap: "20px" }}>
          <div>&nbsp;&nbsp;</div>
          <br></br>
        </div>
      </Box>

      <Box
        className="image-container"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <img
          className="blank-laptop"
          src={require("../img/006.png")}
          alt="Blank Laptop"
          style={{
            width: "80%",
            height: "auto",
            borderRadius: 10,
          }}
        />
      </Box>

      <Box
        className="content-box"
        sx={{
          zIndex: 2,
          width: "90%",
          marginTop: "20px",
          position: "relative",
          bottom: "13%",
        }}
      >
        <Typography
          textAlign="center"
          style={{ fontSize: "120%", marginLeft: "15%" }}
        >
          Grow your{" "}
          <span
            style={{
              fontSize: "100%",
              fontWeight: "bold",
              color: "#696969",
            }}
          >
            {text}
          </span>{" "}
          with all-in-one portfolio tracking and early warning information
          solution.
        </Typography>

        <Button
          className="Check_Prices"
          variant="contained"
          onClick={handlePricing}
          color="primary"
          sx={{
            mt: 5,
            width: "70%",
            fontSize: "100%",
            marginLeft: "20%",
            position: "relative",
            top: "20%",
          }}
        >
          Check Prices
        </Button>
      </Box>
      <AppAppBar
        showSubMenu={false}
        showPricing={true}
        showContactUs={true}
        showPrivacy={true}
        showTermsofService={true}
      />
    </Box>
  );

  return isMobile ? renderMobileContent() : renderDesktopContent();
}
